export default "__VITE_ASSET__DF689LLX__"